var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"column":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('SiteSelect',{attrs:{"site":_vm.site},on:{"site-selected":_vm.siteSelected}})],1),_c('router-view',{attrs:{"name":"banner","site_key":_vm.site}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }